/**
 * @desc demand helper
 */
function getTextBox(item, centerX) {
    var cx = item.cx, cy = item.cy, size = item.size, textWidth = item.textWidth, distance = item.distance, fontSize = item.fontSize;
    var position = item.position;
    if (position === 'outside') {
        if (item.cx > centerX) {
            position = 'right';
        }
        else {
            position = 'left';
        }
    }
    if (position === 'inside') {
        return {
            cx: cx,
            cy: cy,
            width: textWidth,
            height: fontSize,
        };
    }
    if (position === 'left') {
        return {
            cx: cx - size / 2 - distance - textWidth / 2,
            cy: cy,
            width: textWidth,
            height: fontSize,
        };
    }
    if (position === 'right') {
        return {
            cx: cx + size / 2 + distance + textWidth / 2,
            cy: cy,
            width: textWidth,
            height: fontSize,
        };
    }
    if (position === 'top') {
        return {
            cx: cx,
            cy: cy - size / 2 - distance - fontSize / 2,
            width: textWidth,
            height: fontSize,
        };
    }
    if (position === 'bottom') {
        return {
            cx: cx,
            cy: cy + size / 2 + distance + fontSize / 2,
            width: textWidth,
            height: fontSize,
        };
    }
}
function getShapeBox(item) {
    return {
        cx: item.cx,
        cy: item.cy,
        width: item.size,
        height: item.size,
    };
}
function boxCollisionTest(a, b) {
    return (Math.abs(a.cx - b.cx) < (a.width + b.width) / 2 &&
        Math.abs(a.cy - b.cy) < (a.height + b.height) / 2);
}
export function collisionTest(first, second, cx) {
    var firstShapebox = getShapeBox(first);
    var firstTextBox = getTextBox(first, cx);
    var secondShapebox = getShapeBox(second);
    var secondTextBox = getTextBox(second, cx);
    return (boxCollisionTest(firstShapebox, secondShapebox) ||
        boxCollisionTest(firstShapebox, secondTextBox) ||
        boxCollisionTest(firstTextBox, secondShapebox) ||
        boxCollisionTest(firstTextBox, secondTextBox));
}
